<template>
  <page ref="pageRef">
    <div v-if="creditUnions.length > 1" class="container">
      <p class="lender-header">
        Select a lender according to which application you would like to review.
      </p>
      <div class="two-column-grid">
        <div v-for="lender in creditUnions" :key="lender.lenderId">
          <a
            href="#"
            class="lender-img"
            @click="getLenderApplications(lender.lenderId, lender.subdomain)"
          >
            <img :src="lender.image" :alt="`${lender.subdomain}_Logo`" class="icon-banner" />
          </a>
        </div>
      </div>
    </div>
  </page>
</template>
<script setup lang="ts">
import Page from "../components/shared/layout/Page.vue";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import router from "../router";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const pageRef = ref<InstanceType<typeof Page> | null>(null);

const creditUnions = computed(() => store.state.applicationsModule.creditUnions || []);

function getLenderApplications(lenderId: number, subdomain: string) {
  const lenderApps = store.state.applications.filter((c: any) => c.lenderId === lenderId);

  const query = route.query as any;

  if (lenderApps.length === 1) {
		store.dispatch("applicationsModule/setLenderId", lenderApps[0]?.lenderId);
    localStorage.setItem("slc-lid", "" + lenderId);
    store.dispatch("setApplications", lenderApps);
    router.push({
      path: `/applications/${lenderApps[0].referenceId}`,
      query,
    });
  } else {
    // Assuming they have more than one we send them to applications instead
    query.lid = lenderId;
    query.lender = subdomain;
    router.push({ path: "/applications", query });
  }
}

async function hydrateStore() {
  if (store.state.applications.length <= 0) {
    const query = route.query as any;
    router.push({
      path: `/`,
      query,
    });
  }
}

onMounted(async () => {
  pageRef.value?.setLoading(true);
  await hydrateStore();
  pageRef.value?.setLoading(false);
});
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}
.lender-header {
  color: #000;
  font-family: "Montserrat", arial, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 17.175px;
  padding-bottom: 30px;
}
.two-column-grid {
  display: grid;
  grid-auto-rows: 0.25fr;
  grid-template-columns: 0.25fr 0.25fr;
  column-gap: 56px;
  row-gap: 20px;
  margin-bottom: 40px;
}

@media (max-width: 992px) {
  .lender-header {
    text-align: center;
  }
}

@media (max-width: 575px) {
  .two-column-grid {
    display: flex;
    flex-direction: column;
  }
}
.lender-img {
  width: 272px;
  height: 163px;
  border-radius: 6px;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 10px;
}
.icon-banner {
  width: 100%;
  object-fit: contain;
}
</style>
